<script>
export default {
  name: 'BrandForm',
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    initialData: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['update:modelValue', 'submit'],
  data() {
    return {
      localForm: {
        brand_id: null,
        name: '',
        is_active: true,
      }
    }
  },
  watch: {
    modelValue(next) {
      if (next) this.syncForm()
    },
    initialData: {
      deep: true,
      handler() {
        if (this.modelValue) this.syncForm()
      }
    }
  },
  methods: {
    syncForm() {
      this.localForm = {
        brand_id: this.initialData?.brand_id || null,
        name: this.initialData?.name || '',
        is_active: this.initialData?.is_active !== undefined ? !!this.initialData.is_active : true,
      }
    },
    close() {
      this.$emit('update:modelValue', false)
    },
    submit() {
      this.$emit('submit', {
        brand_id: this.localForm.brand_id,
        name: String(this.localForm.name || '').trim(),
        is_active: !!this.localForm.is_active,
      })
    }
  },
  mounted() {
    this.syncForm()
  }
}
</script>

<template>
  <q-dialog :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)">
    <q-card style="min-width: 420px; max-width: 90vw;">
      <q-card-section class="row items-center q-pb-none">
        <div class="text-h6">{{ localForm.brand_id ? '브랜드 수정' : '브랜드 등록' }}</div>
        <q-space />
        <q-btn icon="close" flat round dense @click="close" />
      </q-card-section>

      <q-card-section>
        <q-input
          v-model="localForm.name"
          label="브랜드명"
          outlined
          dense
          autofocus
          class="q-mb-md"
        />
        <q-toggle
          v-model="localForm.is_active"
          label="활성 여부"
        />
      </q-card-section>

      <q-card-actions align="right">
        <q-btn flat label="취소" @click="close" />
        <q-btn color="primary" label="저장" @click="submit" />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>
